require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-front-end-design-development-graduation.json") })
        }
      }, "path---blog-front-end-design-development-graduation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-front-end-design-development-graduation!./.cache/json/blog-front-end-design-development-graduation.json
// module id = 828
// module chunks = 231608221292675